import { useAppStore } from '@/store/appStore';
import { Directive, DirectiveBinding } from 'vue';

/**
 * 叉车 IAM 权限指令 v-forklift-permission。
 * 绑定值为 IAM p_id（string）或 p_id 数组；命中任一即保留元素，否则移除。
 * */
const ForkliftPermissionDirective: Directive = {
  mounted(el, binding: DirectiveBinding<string | string[]>) {
    const v = binding.value;
    const { iamPermission } = useAppStore();

    let verify = false;
    // 数组
    if (Array.isArray(v)) {
      for (let i = 0; i < iamPermission.length; i++) {
        const item = iamPermission[i];
        if (v.includes(item)) {
          verify = true;
          break;
        }
      }
    }
    // 普通
    else {
      verify = iamPermission.includes(v);
    }

    if (!verify) {
      el.parentNode && el.parentNode.removeChild(el);
    }
  },
};

export default ForkliftPermissionDirective;
